import * as React from 'react';
import Layout from '../../components/Utilities/Layout';
import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Common from '../../utilities/common';
import $ from "jquery";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export interface INamesState {
    data: any[];
    loading: boolean;
    selectedSex: string;
}

export default class Names extends React.Component<{}, INamesState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true
        };
    }

    componentDidMount(): void {
        this.Get('mujer');
    }

    public render(): React.ReactElement<{}> {
        return (
            <div>
                <Layout>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <BadgeOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={11}>
                                <Typography className='mainTitle'>
                                Nombres de personas
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={this.state.selectedSex} onChange={(event: React.SyntheticEvent, newValue: string) => {
                                this.setState({
                                    loading: true,
                                    selectedSex: newValue
                                });

                                this.Get(newValue);
                            }}>
                                <Tab label="Mujer" value='mujer'/>
                                <Tab label="Hombre" value='hombre'/>
                            </Tabs>
                        </Box>
                        {
                            this.state.loading && (
                                <div style={{textAlign: 'center', marginTop: '40px'}}>
                                    <CircularProgress />
                                </div>
                            )
                        }
                        {
                            !this.state.loading && this.state.data.length > 0 && (
                                <TableContainer component={Paper} style={{marginTop: '40px', maxHeight: '500px', overflow: 'auto'}}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {
                                                    Object.getOwnPropertyNames(this.state.data[0]).map((value: string, index: number) => {
                                                        return (
                                                            <TableCell key={`th-${index}`}>
                                                                {
                                                                    value
                                                                }
                                                            </TableCell>
                                                        )
                                                    })
                                                }
                                                <TableCell key={`th-actions`}>
                                                    Actions
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                this.state.data.map((row: any, rowIndex: number) => {
                                                    return (
                                                        <TableRow key={`tr-${rowIndex}`}>
                                                            {
                                                                Object.getOwnPropertyNames(row).map((key: string, cellIndex: number) => {
                                                                    return (
                                                                        <TableCell key={`tr-${rowIndex}-td-${cellIndex}`}>
                                                                            {
                                                                                row[key]
                                                                            }
                                                                        </TableCell>
                                                                    )
                                                                })
                                                            }
                                                            <TableCell style={{width: '10%'}}>
                                                                <IconButton aria-label="delete">
                                                                    <EditOutlinedIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )
                        }
                    </Box>
                    <Box className='stepper' sx={{textAlign: 'right'}}>
                        <Button variant="text">
                            Nuevo nombre
                        </Button>
                    </Box>
                </Layout>
            </div>
        )
    }

    private Get(sex: string): void {
        let url = `${Common.END_POINT}/masters/nameswithsex/${sex}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    loading: false
                }
            );
        })
    }
}